import { ActivityTitle } from "./ActivityTitle"
import { CastTitle } from "./CastTitle"
import { ContractTitle } from "./ContractTitle"
import { PersonName } from "./PersonName"
import { ProductionTitle } from "./ProductionTitle"

function parseObjectTypeAndIdFromUrl() {
  const path = window.location.pathname
  const patterns = [
    { regex: /^\/app\/contacts\/(\d+)/, objectTypeId: 1 },
    { regex: /^\/app\/art\/activities\/(\d+)/, objectTypeId: 2 },
    { regex: /^\/app\/cast\/(\d+)/, objectTypeId: 3 },
    { regex: /^\/app\/contracts\/contracts\/(\d+)/, objectTypeId: 4 },
    { regex: /^\/app\/art\/productions\/(\d+)/, objectTypeId: 5 },
  ]
  for (const { regex, objectTypeId } of patterns) {
    const match = path.match(regex)
    if (match) return { objectTypeId, objectId: Number(match[1]) }
  }
  return { objectTypeId: null, objectId: null }
}

export function useGetCurrentObjectTitle() {
  const { objectTypeId, objectId } = parseObjectTypeAndIdFromUrl()
  switch (objectTypeId) {
    case 1:
      return <PersonName personId={objectId} />
    case 2:
      return <ActivityTitle activityId={objectId} />
    case 3:
      return <CastTitle castId={objectId} />
    case 4:
      return <ContractTitle contractId={objectId} />
    case 5:
      return <ProductionTitle productionId={objectId} />
    default:
      return null
  }
}
